module.exports = __webpack_public_path__ + "afcbba583033f466fe52515916c687bd.svg";